import { Icon } from "./Icon.tsx";

/** "Add Orifice" tool icon — AddConduitIcon.tsx's own two-nodes-joined-by-a-pipe glyph, with a small open circle (the opening) at the midpoint marking it as an orifice rather than a plain conduit. */
export function AddOrificeIcon() {
  return (
    <Icon>
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      <path d="M7 17.5L17 6.5" />
      <circle cx="12" cy="12" r="2" />
    </Icon>
  );
}
